import { Tooltip } from "@mantine/core";
import { IconCloudDownload, IconCloudOff } from "@tabler/icons-react";
import type { MRT_ColumnDef, MRT_RowData } from "mantine-react-table-open";
import { useGenerators } from "../../../../hooks/useGenerators";

interface GetGeneratorRedispatchColumnProps {
  generatorId?: number;
  siteId?: number;
  generatorIdFieldName?: string;
}

function SmartGeneratorRedispatchCell({
  siteId,
  generatorId
}: {
  siteId: number;
  generatorId: number;
}) {
  const { data: generators, error } = useGenerators({ siteId });
  const generator = generators?.find(
    (generator) => generator.id === generatorId
  );

  if (error) return <>{error.message}</>;

  return (
    <GeneratorRedispatchCell
      isRedispatchImportActive={generator?.isRedispatchImportActive}
      isRedispatchImportActiveForOperator={
        generator?.isRedispatchImportActiveForOperator
      }
    />
  );
}

function GeneratorRedispatchCell({
  isRedispatchImportActive,
  isRedispatchImportActiveForOperator
}: {
  isRedispatchImportActive: boolean | null | undefined;
  isRedispatchImportActiveForOperator: boolean | null | undefined;
}) {
  if (
    isRedispatchImportActive === undefined ||
    !isRedispatchImportActiveForOperator
  ) {
    return null;
  }

  if (isRedispatchImportActive) {
    return (
      <Tooltip label="Diese Anlage ist für den automatischen Datenimport von Energiemengen aus Redispatch- und Direktvermarkter-Abregelungen lizensiert.">
        <IconCloudDownload />
      </Tooltip>
    );
  }
  return (
    <Tooltip label="Diese Anlage ist nicht für den automatischen Datenimport von Energiemengen aus Redispatch- und Direktvermarkter-Abregelungen lizensiert.">
      <IconCloudOff />
    </Tooltip>
  );
}

function getGeneratorRedispatchColumn<T extends MRT_RowData>({
  generatorId,
  siteId,
  generatorIdFieldName = "generator_id"
}: GetGeneratorRedispatchColumnProps = {}): MRT_ColumnDef<T> {
  return {
    header: "Redispatch / DVA Import",
    accessorKey: "is_redispatch_import_active",
    enableEditing: false,
    size: 130,
    Cell: ({ cell }) => {
      if (
        cell.row.original.is_redispatch_import_active !== undefined &&
        cell.row.original.is_redispatch_import_active !== "" &&
        cell.row.original.is_redispatch_import_active_for_operator !== undefined
      ) {
        return (
          <GeneratorRedispatchCell
            isRedispatchImportActive={
              cell.row.original.is_redispatch_import_active
            }
            isRedispatchImportActiveForOperator={
              cell.row.original.is_redispatch_import_active_for_operator
            }
          />
        );
      } else {
        return (
          <SmartGeneratorRedispatchCell
            generatorId={cell.row.original[generatorIdFieldName] || generatorId}
            siteId={cell.row.original.site_id || siteId}
          />
        );
      }
    }
  };
}

export { getGeneratorRedispatchColumn };
